import type { ModelClient } from './client'
import type { ListingOrganization, ListingProfile } from './listing'
import type { User } from './user'

export enum ActivitySource {
  admin = 'admin',
  app = 'app',
}

export enum ActivityType {
  create = 'create',
  update = 'update',
  delete = 'delete',
  view = 'view',
  preview = 'preview',
  download = 'download',
  import = 'import',
  contact = 'contact',
  login = 'login',
  viewLink = 'viewLink',
  notification = 'notification',
}

export enum ActivityRelatedType {
  client = 'client',
  broker = 'broker',
  email = 'email',
  listing = 'listing',
  report = 'report',
  search = 'search',
  user = 'user',
}

export type ActivityRelated = {
  _id: string
  id: string
  tid: string
  slug: string
  name?: string
  first_name?: string
  last_name?: string
  subject?: string
  organization?: ListingOrganization
}

export type Activity = {
  _id: string
  tid: string
  client: ModelClient
  created: string
  user?: User
  historyId?: string
  source: ActivitySource
  type: ActivityType
  relatedType: ActivityRelatedType
  related: ActivityRelated
  brokers?: ListingProfile[]
  meta?: { [key: string]: any }
  referer?: string
  geolocation?: {
    city: string
    stateAbbr?: string
    country: string
    latitude: string
    longitude: string
  }
}

export type ActivityData = Pick<
  Activity,
  | 'source'
  | 'type'
  | 'relatedType'
  | 'related'
  | 'brokers'
  | 'meta'
  | 'historyId'
>
